/**
 * Determines whether the provided navigator user agent belongs to a mobile device
 *
 * @param {Object}  navigator    The window navigator
 *
 * @returns {boolean} Whether device is mobile
 */
const isMobileDevice = (navigator) => {
  if (!navigator || !navigator.userAgent) {
    return false
  }

  return !!(
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  )
}

export default isMobileDevice
